// extracted by mini-css-extract-plugin
export default {"rail":"VerticalTabs_rail__UffY-","tab":"VerticalTabs_tab__D8ubJ","tab_active":"VerticalTabs_tab_active__KSPKy"};